import React from 'react';
import './ErrorBoundary.css';

class SectionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`[SectionErrorBoundary: ${this.props.section || 'inconnu'}]`, error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      const section = this.props.section || 'Cette section';

      return (
        <div className="error-boundary--section">
          <div className="error-boundary-card">
            <div className="error-boundary-icon">Oups</div>
            <h3 className="error-boundary-title">
              {section} n'a pas pu se charger
            </h3>
            <p className="error-boundary-message">
              Un problème est survenu. Vous pouvez réessayer.
            </p>
            <div className="error-boundary-actions">
              <button
                onClick={this.handleRetry}
                className="error-boundary-btn error-boundary-btn--primary"
              >
                Réessayer
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default SectionErrorBoundary;
